$('body').on('click', '[data-toggle="plandetails-popup"]', function(event) {
    let loader = $(this).parent().find('.loader');
    $(loader).addClass('loadershow');
    $(loader).removeClass('loaderhide');
    event.preventDefault();
    event.stopPropagation();
    createPlandetailsPopup($(this));
});

let updateColourSize = false;

$('#product-ajax-response-holder').on('click', '#product-selection-options-toggle a', function(event) {
    event.preventDefault();
    let url = $(this).attr('href');
    processColourSizeChanges(url);
});

$('#product-ajax-response-holder').on('change keypress', '.out-of-stock-email', function() {
    validateEmail();
    $('.save-email-button').prop('disabled', !$('.out-of-stock-email').val());
});

$('#product-ajax-response-holder').on('change keypress', '.out-of-stock-email-mobile', function() {
    validateEmail();
    $('.save-email-button').prop('disabled', !$('.out-of-stock-email-mobile').val());
});

// Call ajax function to insert data on desktop
$('#product-ajax-response-holder').on('click', '#out-of-stock-email-submit-btn', function() {
    event.preventDefault();
    const emailInput = document.getElementById('out-of-stock-email').value;
    const productMake = document.getElementById('product-make').value;
    const productModel = document.getElementById('product-model').value;
    const productHandsetCode = document.getElementById('product-handset-code').value;
    const productBaseCode = document.getElementById('product-base-code').value;
    if (emailInput != '') {
        insertEmailForOutOfStock(emailInput, productMake, productModel, productHandsetCode, productBaseCode);
    }
});

// Call ajax function to insert data on mobile
$('#product-ajax-response-holder').on('click', '#out-of-stock-email-submit-mobile-btn', function() {
    event.preventDefault();
    const emailInput = document.getElementById('out-of-stock-email-mobile').value;
    const productMake = document.getElementById('product-make-mobile').value;
    const productModel = document.getElementById('product-model-mobile').value;
    const productHandsetCode = document.getElementById('product-handset-code-mobile').value;
    const productBaseCode = document.getElementById('product-base-code-mobile').value;
    if (emailInput != '') {
        insertEmailForOutOfStock(emailInput, productMake, productModel, productHandsetCode, productBaseCode);
    }
});

function validateEmail() {
    const emailInput = document.querySelector('.out-of-stock-email');
    const emailmobInput = document.querySelector('.out-of-stock-email-mobile');
    const email = emailInput ? emailInput.value : '';
    const emailmob = emailmobInput ? emailmobInput.value : '';
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const helpBlocks = document.querySelectorAll('.help-block');

    if (email && emailPattern.test(email) === false) {
        helpBlocks.forEach((block) => {
            block.textContent = 'Please enter a valid email address';
            block.style.display = 'block';
        });
    } else if (emailmob && emailPattern.test(emailmob) === false) {
        helpBlocks.forEach((block) => {
            block.textContent = 'Please enter a valid email address';
            block.style.display = 'block';
        });
    } else {
        helpBlocks.forEach((block) => {
            block.style.display = 'none';
        });
    }
}

function insertEmailForOutOfStock(emailInput, productMake, productModel, productHandsetCode, productBaseCode) {
    let outOfStockEmailUrl = '/out_of_stock_email_page';
    let options = {};
    options['email'] = emailInput;
    options['productMake'] = productMake;
    options['productModel'] = productModel;
    options['productHandsetCode'] = productHandsetCode;
    options['productBaseCode'] = productBaseCode;

    const formData = new URLSearchParams(options);

    fetch(outOfStockEmailUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData.toString()
    })
        .then(response => response.json())
        .then((data) => {
        // Check if the response indicates success
            if (data.statusCode === '200' && data.status === 'success') {
                const successElements = document.querySelectorAll('.out-of-stock-signup-success');
                const signupDivElements = document.querySelectorAll('.out-of-stock-signup-div');
                successElements.forEach(el => el.style.display = 'block');
                signupDivElements.forEach(el => el.style.display = 'none');
            } else {
                const helpBlocks = document.querySelectorAll('.help-block');
                helpBlocks.forEach((block) => {
                    block.textContent = data.message;
                    block.style.display = 'block';
                });
            }
        })
        .catch((error) => {
        // Handle any errors that occurred during the request
            const helpBlocks = document.querySelectorAll('.help-block');
            helpBlocks.forEach((block) => {
                block.textContent = 'Request failed: ' + error.message;
                block.style.display = 'block';
            });
        });
}

function processColourSizeChanges(url) {
    updateColourSize = true;
    showLoader();
    window.history.pushState(null, document.title, url);
    let queryOverrides = {};
    if (updateColourSize) {
        queryOverrides.updateColourSize = '1';
    }
    $.getJSON(document.URL, queryOverrides)
        .done(dataColourSizeReceived)
        .always(hideLoader);
    updateColourSize = false;
}

function dataColourSizeReceived(data) {
    updateColourSize = false;

    // Below code is commented and replaced because jquery html() appends data and then removes old data. The problem with this approach is that any JS variables which were inside this data will attempt to be redeclared which will throw an error on console and stop any further JS execution. A lot of jquery methods are outdated in their approach and better vanila alternatives exists.
    // $('#product-ajax-response-holder').html(data.listing.dealColourSizeUpdate);
    document.getElementById('product-ajax-response-holder').innerHTML = data.listing.dealColourSizeUpdate;
    if (typeof insertRAFBanner === 'function') {
        insertBannerElement();
    }
    if (typeof observeDOM === 'function') {
        observeDOM();
    }
    if (typeof insertRAFBanner === 'function') {
        insertRAFBanner();
    }
    if (typeof loadCompareQualityButton === 'function') {
        const productNameElement = document.querySelector('div.product-details-selection h1 span[itemprop="name"]');
        if (productNameElement && productNameElement.innerHTML.toLowerCase().includes('refurbished')) {
            loadCompareQualityButton();
        }
    }
    // Because of ID's being shared on modal, this temporary patch is needed. Can be removed after MOB-3854 goes live.
    if (typeof tempPatchIdDuplicationForModal == 'function') {
        tempPatchIdDuplicationForModal();
    }
    // Product page image swiper needs to be re-initiated
    if (document.getElementsByClassName('product-page-swiper-container').length > 0) {
        new Swiper('.product-page-swiper-container',
            {
                pagination: '.swiper-pagination',
                paginationClickable: '.swiper-pagination',
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                simulateTouch: false,
                setWrapperSize: true,
                spaceBetween: 0,
                keyboardControl: true,
                loop: true
            }
        );
    }
}

function showLoader() {
    $('#page-loader').fadeIn();
}

function hideLoader() {
    $('#page-loader').fadeOut();
}

function createPlandetailsPopup(el) {
    createModalPopup(
        el,
        $('.plandetails-popup'),
        '/ajax/plandetails.json',
        ['hstarid']
    );
}

function createModalPopup(el, target, ajaxUrl, optionKeys) {
    let cachedModalHtml = el.data('cached-modal-html');
    let options = {};

    $(optionKeys).each(function(key, val) {
        options[val] = el.data(val);
    });

    if (!ajaxUrl) {
        cachedModalHtml = target.html();
    }

    $.ajax({
        dataType: 'json',
        url: ajaxUrl,
        data: options,
        success: function(data) {
            $('.loader').removeClass('loadershow');
            if (data.success) {
                cachedModalHtml = data.html;
                el.data('cached-modal-html', cachedModalHtml);
                target.html(cachedModalHtml);
                $(target).modal();
            }
        }
    });
}

jQuery(document).ready(function($) {
    let plandetailsPopupLink = '';
    switch (window.location.hash) {
        case '#plandetails-popup':
            plandetailsPopupLink = $('[data-toggle="plandetails-popup"]').first();
            if (plandetailsPopupLink.length) {
                createPlandetailsPopup(plandetailsPopupLink);
            }
            break;
    }

    function toggleAddressSection() {
        let simTypeContainer = $('.form-section-radio-buttons');
        let physicalSimSelected = simTypeContainer.find('input[type="radio"][value="PSIM"]').is(':checked');
        let esimSimElement = document.querySelector('input[type="radio"][value="ESIM"]');
        let productName = document.querySelector('.product-name').textContent.trim();
        if (productName) {
            productName.textContent.trim();
        }
        let manufacturer = document.querySelector('.manufacturer').textContent.trim();
        if (manufacturer) {
            manufacturer.textContent.trim();
        }
        let contractType = document.querySelector('.contract-type').textContent.trim();
        if (contractType) {
            contractType.textContent.trim();
        }
        let hasAccessories = hasAccessoryInCart();

        $('p.esimselect').hide();
        $('.address-column-checkbox').find('#form_deliveryAddressEnable_enabled').prop('checked', false);
        if (esimSimElement && productName) {
            if (esimSimElement.checked == true && productName.includes('SIM')) {
                if (document.querySelector('div[data-delivery-selection-id="containing-block"]')) {
                    $('div[data-delivery-selection-id="containing-block"]').hide();
                }
            } else if (esimSimElement.checked == false && productName.includes('SIM')) {
                if (document.querySelector('div[data-delivery-selection-id="containing-block"]')) {
                    $('div[data-delivery-selection-id="containing-block"]').show();
                }
            }
        }

        if (physicalSimSelected == false && productName && productName.includes('SIM')) {
            $('.address-column-checkbox').hide();
            $('div[data-address-id="delivery_address_block"]').addClass('hide');
            $('p.esimselect').show();
        } else {
            $('.address-column-checkbox').show();
        }
        if (physicalSimSelected == '' && productName && productName.includes('SIM')) {
            $('.address-column-checkbox').hide();
        } else if (physicalSimSelected == '') {
            $('.address-column-checkbox').show();
        }
        if (hasAccessories && productName && productName.includes('SIM')) {
            $('p.esimselect').hide();
            $('.address-column-checkbox').show();
        }
        if (manufacturer == 'Voxi') {
            $('.address-column-checkbox').show();
        }
        if (contractType == '(Upgrade)') {
            $('p.esimselect').hide();
            $('.address-column-checkbox').show();
        }
    }
    toggleAddressSection();

    $('.form-section-radio-buttons').on('change', 'input[type="radio"][value="PSIM"], input[type="radio"][value="ESIM"]', function() {
        let radioId = $(this).attr('id');
        let labelText = $('label[for="' + radioId + '"]').text().trim();
        $('.sim-type-choice-column-value').text(labelText);
        toggleAddressSection();

        if ($(this).val() === 'PSIM' && !$('.address-column-checkbox').length) {
            setTimeout(() => window.location.reload(true), 500);
        }
    });

    function hasAccessoryInCart() {
        return document.querySelectorAll('.product-name[data-producttype="Accessory"]').length > 0;
    }
});
